var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiabetes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 460.91 460.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;stroke-linecap:round;stroke-width:14px;}.cls-1{stroke:#ed7330;}.cls-1,.cls-2{stroke-miterlimit:10;}.cls-2,.cls-3{stroke:#222456;}.cls-3{stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.32,253.47l-16.2,28a28,28,0,1,0,48.58,0l-16.19-28c-3.34-5.79-12.85-5.79-16.19,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.71,118H81.39a9.34,9.34,0,0,0-9.34,9.34v93.41a9.33,9.33,0,0,0,9.34,9.34H197a98,98,0,0,0,95.85-78.57A28,28,0,0,0,265.36,118h-5.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M322.11,252.47a27.84,27.84,0,0,0-31.69-5.27l-22.75-22.75a116.54,116.54,0,0,1-16,10.39l25.57,25.57a27.82,27.82,0,0,0,5.27,31.69l66,66a9.34,9.34,0,0,0,13.21,0l26.42-26.41a9.34,9.34,0,0,0,0-13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M168,178.61h45.44a45.49,45.49,0,0,0,45.45-45.44V118H168Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 230.45,
    cy: 230.45,
    r: 223.45
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiabetes);
export default __webpack_public_path__ + "static/media/diabetes.51519707.svg";
export { ForwardRef as ReactComponent };